module.exports = "<div class=\"panel-clear-filter hidden-xs\" ng-if=carouselFilterApplied><a href=\"\" ng-click=showAllAirlines()><l10n>Clear filter/s</l10n></a></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trains-base/templates/flights/trains-clear-filters.html
// module id = 3270
// module chunks = 0